import src from "IMAGE";
export default { src, width: 2074, height: 354, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ALeb9f+zlvX/qIb0/7GT9f+0l/X/r5D0/7aa9f+oh/P/pD4Zs8SUz5QAAAAASUVORK5CYII="};
